import { en, id } from "@/i18n";
import { toAbsoluteUrl } from "@/lib/helpers";

import type { Language } from "@/types/i18n";

const I18N_MESSAGES = {
	en,
	id,
};

const I18N_CONFIG_KEY = "i18nConfig";

const I18N_LANGUAGES: Language[] = [
	{
		label: "Indonesia",
		code: "id",
		direction: "ltr",
		flag: toAbsoluteUrl("/media/flags/indonesia.svg"),
		messages: I18N_MESSAGES.id,
	},
	{
		label: "English",
		code: "en",
		direction: "ltr",
		flag: toAbsoluteUrl("/media/flags/united-states.svg"),
		messages: I18N_MESSAGES.en,
	},
];

const I18N_DEFAULT_LANGUAGE: Language = I18N_LANGUAGES[0];

export {
	I18N_CONFIG_KEY,
	I18N_DEFAULT_LANGUAGE,
	I18N_LANGUAGES,
	I18N_MESSAGES,
};
